import { Layout } from "antd";
import React from "react";
import ForgotPasswordForm from "../../components/Forms/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  return (
    <Layout>
      <Layout.Content>
        <ForgotPasswordForm />
      </Layout.Content>
    </Layout>
  );
};

export default ForgotPasswordPage;
